import Home from './Displays/Home';
import CombinedWindSolar from './Charts/CombinedWindSolar';
import Interchange from './Charts/Interchange';
import OperationsDisplays from './Displays/OperationsDisplays';
import MarketDisplays from './Displays/MarketsDisplays';
import FuelMix from './Charts/FuelMix';
import SupplyAndDemandChart from './Charts/SupplyAndDemand';
import RegionalDirectionalTransfer from './Charts/RegionalDirectionalTransfer';
import GenerationOutages from './Charts/GenerationOutages';
import Pod from './Components/Pod';
import RealTimeTotalLoad from './Charts/RealTimeTotalLoad';
import AreaControlError from './Charts/AreaControlError';
import Disclaimer from './Components/Disclaimer';
import NextDayShortTermReserveRequirement from './Charts/NextDayShortTermReserveRequirement';
import ExAnteLmp from './Charts/ExAnteLmp';
import RealTimeBindingConstraints from './Charts/RealTimeBindingConstraints';
import SubRegionalPowerBalanceBindingConstraints from './Charts/SubRegionalPowerBalanceBindingConstraints';
import ReserveProductsBindingConstraints from './Charts/ReserveProductsBindingConstraints';
import RealTimeRSGCommitments from './Charts/RealTimeRSGCommitments';
import CoordinatedTransactionScheduling from './Charts/CoordinatedTransactionScheduling';
import AncillaryServicesMCP from './Charts/AncillaryServicesMCP';
import LmpConsolidatedTable from './Charts/LmpConsolidatedTable';
import LMPContourMap from './Charts/LMPContourMap';

export interface RouteOptionsConfig {
	option: string;
	description: string;
}

export interface RoutesConfig {
	name: string;
	route: string;
	component: JSX.Element;
	addLineBreak?: boolean;
	options?: RouteOptionsConfig[];
	type?: 'Ops' | 'Mkts';
}

const routes: RoutesConfig[] = [
	{
		name: 'Home',
		route: '/',
		component: <Home />
	},
	{
		name: 'Operations Displays',
		route: '/operations-displays',
		component: <OperationsDisplays />,
		addLineBreak: true,
		type: 'Ops'
	},
	{
		name: 'Markets Displays',
		route: '/markets-displays',
		component: <MarketDisplays />,
		addLineBreak: true,
		type: 'Mkts'
	},
	{
		name: 'Combined Wind and Solar',
		route: '/cwsc',
		options: [
			{
				option: 'twoDays=true',
				description: 'Showing Two Days'
			}
		],
		component: <Pod title='Wind and Solar Forecast and Real-Time Generation' Chart={CombinedWindSolar} />,
		type: 'Ops'
	},
	{
		name: 'Interchange',
		route: '/interchange',
		component: <Pod title='Region-Wide Total Imports(-)/Exports(+)' Chart={Interchange} />,
		type: 'Ops'
	},
	{
		name: 'Fuel Mix',
		route: '/fuelmix',
		component: <Pod title='Fuel Mix' Chart={FuelMix} />,
		type: 'Ops'
	},
	{
		name: 'Supply And Demand',
		route: '/supplydemand',
		options: [
			{
				option: 'hideTitleBar=true',
				description: 'Hidden Title Bar'
			}
		],
		component: <Pod title='Supply and Demand' Chart={SupplyAndDemandChart} />,
		type: 'Ops'
	},
	{
		name: 'Regional Directional Transfer',
		route: '/rdt',
		component: <Pod title='Regional Directional Transfer' Chart={RegionalDirectionalTransfer} />,
		type: 'Ops'
	},
	{
		name: 'Generation Outages',
		route: '/genout',
		component: <Pod title='Generation Outages' Chart={GenerationOutages} />,
		type: 'Ops'
	},
	{
		name: 'Real-Time Total Load',
		route: '/rttl',
		component: <Pod title='Real-Time Total Load' Chart={RealTimeTotalLoad} />,
		type: 'Ops'
	},
	{
		name: 'Next-Day Short-Term Reserve Requirement',
		route: '/resreq',
		component: <Pod title='Next-Day Short-Term Reserve Requirement' Chart={NextDayShortTermReserveRequirement} />,
		type: 'Ops'
	},
	{
		name: 'ACE',
		route: '/ace',
		component: <Pod title='ACE Chart' Chart={AreaControlError} />,
		type: 'Ops'
	},
	{
		name: 'Disclaimer',
		route: '/disclaimer',
		component: <Disclaimer extraMargin={true} />
	},
	{
		name: 'LMP Contour Map',
		route: '/lmpcontourmap',
		component: <Pod title='LMP Contour Map' Chart={LMPContourMap} />,
		type: 'Mkts'
	},
	{
		name: 'ExAnte LMP',
		route: '/exantelmp',
		component: <Pod title='ExAnte LMP' Chart={ExAnteLmp} />,
		type: 'Mkts'
	},
	{
		name: 'Real-Time Binding Constraints',
		route: '/realtimebindingconstraints',
		component: <Pod title='Real-Time Binding Constraints' Chart={RealTimeBindingConstraints} />,
		type: 'Mkts'
	},
	{
		name: 'LMP Consolidated Table',
		route: '/lmpconsolidatedtable',
		component: <Pod title='LMP Consolidated Table' Chart={LmpConsolidatedTable} />,
		type: 'Mkts'
	},
	{
		name: 'Ancillary Services MCP',
		route: '/ancillaryservicesmcp',
		component: <Pod title='Ancillary Services MCP' Chart={AncillaryServicesMCP} />,
		type: 'Mkts'
	},
	{
		name: 'Reserve Products Binding Constraints',
		route: '/reserveproductsbindingconstraints',
		component: <Pod title='Reserve Products Binding Constraints' Chart={ReserveProductsBindingConstraints} />,
		type: 'Mkts'
	},
	{
		name: 'Sub-Regional Power Balance Binding Constraints',
		route: '/subregionalpowerbalancebindingconstraints',
		component: <Pod title='Sub-Regional Power Balance Binding Constraints' Chart={SubRegionalPowerBalanceBindingConstraints} />,
		type: 'Mkts'
	},
	{
		name: 'Real-Time RSG Commitments',
		route: '/realtimersgcommitments',
		component: <Pod title='Real-Time RSG Commitments' Chart={RealTimeRSGCommitments} />,
		type: 'Mkts'
	},
	{
		name: 'Coordinated Transaction Scheduling',
		route: '/coordinatedtransactionscheduling',
		component: <Pod title='Coordinated Transaction Scheduling' Chart={CoordinatedTransactionScheduling} />,
		type: 'Mkts'
	}
];

export default routes;
